import { render, staticRenderFns } from "./artistGroupsNav.vue?vue&type=template&id=7c1f5620"
import script from "./artistGroupsNav.vue?vue&type=script&lang=js"
export * from "./artistGroupsNav.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports